import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";

import CustomButton from "../../helper-components/input/CustomButton";

import { defaultId, defaultStyle, defaultTime } from "./shared.js";

// Render functions.
const renderManualUse = (params) => {
    const inUse = params.row.manual_use;
    const formatted = inUse ? "Manually set to be used" : "Not manually set, latest cookie will be used";

    if (inUse) {
        return <CustomButton icon={<DoneIcon className="cursor-default" />} tooltip={formatted} />;
    }

    return <CustomButton icon={<CloseIcon className="cursor-default" />} tooltip={formatted} />;
};

// Column definitions.
const type = { ...defaultStyle, field: "type", headerName: "Type", flex: 0.1, minWidth: 100 };
const note = { ...defaultStyle, field: "note", headerName: "Note", flex: 0.25, minWidth: 175 };
const manual_use = { ...defaultStyle, field: "manual_use", headerName: "Manual overwrite", flex: 0.1, minWidth: 75, renderCell: (params) => renderManualUse(params) };
const createdOn = { ...defaultTime("created_on"), headerName: "Created on" };

// Table columns.
export const columns = (props) => [defaultId, type, note, manual_use, createdOn];

// Style and other misc. functions.
export const isRowSelectable = (props, params) => {
    return true;
};

// Default aggregate props of the table.
export const defaultTableOptions = {
    isRowSelectable,
    checkboxSelection: true
};
